import React from 'react'
import "./Comming_soon.css"

function Comming_soon() {
    return (
        <>
            <section className='Comming_soon'>
                <img src="/assets/video/Comming_soon/Comming_soon.png" className='Comming_soon_vdo' />
            </section>
        </>
    )
}

export default Comming_soon